export default __webpack_public_path__ + "static/media/accountBlocked.753498d3.svg";